export function removeGst(totalPrice: number): number {
  const priceExcludingGst = totalPrice / 1.15
  return priceExcludingGst
}
